import { render, staticRenderFns } from "./realEstatesPickerForBuilding.vue?vue&type=template&id=c1755a0c&"
import script from "./realEstatesPickerForBuilding.vue?vue&type=script&lang=js&"
export * from "./realEstatesPickerForBuilding.vue?vue&type=script&lang=js&"
import style0 from "./realEstatesPickerForBuilding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports